<template>
<div class="shadow-box" v-if="accountInfo">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0;">
    <span>设置</span>
  </div>
  <div>
    <div class="item">
      <label>账号名称</label>{{ accountInfo.nickName || '--' }}
    </div>
    <div class="item">
      <label>手机号</label>{{ accountInfo.mobilePhone || '--' }}
    </div>
  </div>
  <div>
    <div class="item">
      <label>佣金比例</label>
      <template v-if="isEdit">
        <el-input v-model="form.commissionRate"
          @input="handleCommissionInput"
          placeholder="请输入佣金比例" style="width: 200px;">
          <template slot="append">%</template>
        </el-input>
        <el-button type="primary" @click="modifyBdClientCommissionRate" class="btn">保存</el-button>
        <el-button @click="isEdit = false">取消</el-button>
      </template>
      <template v-else>
        <span v-if="commissionRate === null">--</span>
        <span v-else><span>{{ commissionRate }}</span> %</span>
        <el-button class="btn" type="text" @click="isEdit = true; form.commissionRate = commissionRate">修改</el-button>
      </template>
    </div>
    
  </div>
</div>
</template>

<script>
import {
  getBdClientCommissionRate,
  modifyBdClientCommissionRate
} from '@/service/apis/mall'
export default {
  name: 'Home',
  data () {
    return {
      accountInfo: null,
      commissionRate: null,
      isEdit: false,
      form: {
        commissionRate: null
      }
    }
  },
  created () {
    let accoutDto = localStorage.getItem('ACCOUNT_DTO')
    this.accountInfo = JSON.parse(accoutDto)
    // 获取C端设置佣金比例
    this.getBdClientCommissionRate()
  },
  methods: {
    getBdClientCommissionRate () {
      getBdClientCommissionRate.call(this).then(({ commissionRate }) => {
        if (commissionRate && isNaN(Number(commissionRate)) === false) {
          this.commissionRate = Number(commissionRate) / 1000
        } else {
          this.commissionRate = ''
        }
      })
    },

    handleCommissionInput (value) {
      // 使用正则表达式限制只能输入数字和最多2位小数点
      this.form.commissionRate = value.replace(/[^0-9.]/g, '').replace(/\.{2,}/g, '.').replace(/(\.[0-9]{2})[0-9]*/g, '$1');
    },
    modifyBdClientCommissionRate () {
      let commissionRate = this.form.commissionRate
      if (commissionRate === null || commissionRate === '') {
        this.$message.error('请输入佣金比例')
        return
      }
      commissionRate = !isNaN(Number(commissionRate)) ?  Number(commissionRate) * 1000 : 0
      modifyBdClientCommissionRate.call(this, {
        commissionRate
      }).then(res => {
        this.isEdit = false
        this.commissionRate = (commissionRate || 0) / 1000
      })
    }
  }
}
</script>
<style scoped>
.item {
  padding-left: 12px;
  line-height: 32px;
  color: #333;
}
.item label {
  display: inline-block;
  min-width: 120px;
  color: #666;
}
.btn {
  margin-left: 12px;
}
.shadow-box {
  padding: 12px 24px 16px 24px;
}
</style>
